import { requestApi } from 'api/Api';

export const getCdtCodes = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/get', navigate, params });
